// @ts-nocheck

import { useRef, useEffect, useState, useCallback } from 'react';
import { useScrollTo } from '@eti/utils';
import { isSeatsSelectedForCurrentSegment } from '../../../utils/currentSeatSelection';
import { isActive, isFirstAvailableSegment, isLastAvailableSegment, findIndexOfSegment, getSegment } from '../../../utils/segments';
import FromToLabel from '../../../components/FromToLabel';
import StepIndicatorWrapper from './StepIndicatorWrapper';
import StepIndicatorItem from './StepIndicatorItem';

// todo: remove usage of any
import { jsx as _jsx } from "react/jsx-runtime";
const StepIndicator = _ref => {
  let {
    flattenedBounds,
    active,
    allSelectedSeats,
    shouldShowSummary,
    onNextSegmentClick,
    onPreviousSegmentClick,
    onSegmentClick
  } = _ref;
  const indicatorRef = useRef(null);
  const {
    scroll
  } = useScrollTo(indicatorRef);
  const progress = findIndexOfSegment(flattenedBounds, active[0]);
  const isVisited = boundSegmentId => findIndexOfSegment(flattenedBounds, boundSegmentId[1]) <= progress;
  const isFirstSegment = isFirstAvailableSegment(flattenedBounds, active[0]);
  const isLastSegment = isLastAvailableSegment(flattenedBounds, active[0]);
  const isChecked = boundSegmentId => isSeatsSelectedForCurrentSegment(allSelectedSeats, boundSegmentId);
  const isCurrent = boundSegmentId => isActive(shouldShowSummary, boundSegmentId, active);
  const generateKey = boundSegmentId => `${boundSegmentId[0]}-${boundSegmentId[1]}`;
  const getIndicatorItemScrollDiff = (itemRect, indicatorRect) => {
    const shouldScrollLeft = itemRect.left < indicatorRect.left;
    if (shouldScrollLeft) {
      return itemRect.left - indicatorRect.left;
    }
    return itemRect.right - indicatorRect.right;
  };
  const onItemSelected = useCallback(itemRect => {
    const indicatorElement = indicatorRef.current;
    if (indicatorElement) {
      const {
        scrollLeft: indicatorScrollLeft
      } = indicatorElement;
      const indicatorRect = indicatorElement.getBoundingClientRect();
      const isItemVisible = itemRect.left >= indicatorRect.left && itemRect.right <= indicatorRect.right;
      if (isItemVisible) {
        return;
      }
      const scrollDiff = getIndicatorItemScrollDiff(itemRect, indicatorRect);
      scroll('smooth', 0, indicatorScrollLeft + scrollDiff);
    }
  }, [scroll]);
  const [origin, setOrigin] = useState(0);
  useEffect(() => {
    setOrigin(progress);
  }, [progress]);

  // this function calculates how long should the animation be delayed for each item depending on animation direction
  // there is no animation on items, that do not fall between origin and destination, therefore the delay can be negative
  const calculateAnimationDelay = boundSegmentId => Math.sign(progress - origin) * (findIndexOfSegment(flattenedBounds, ...boundSegmentId) - origin) / flattenedBounds.length;
  const onStepIndicatorClick = segment => () => onSegmentClick === null || onSegmentClick === void 0 ? void 0 : onSegmentClick(segment);
  const currentSegment = getSegment(flattenedBounds, active[0]);
  return /*#__PURE__*/_jsx(StepIndicatorWrapper, {
    innerRef: indicatorRef,
    isFirstSegment: isFirstSegment,
    isLastSegment: isLastSegment,
    length: flattenedBounds.length - 1,
    onNextSegmentClick: onNextSegmentClick,
    onPreviousSegmentClick: onPreviousSegmentClick,
    progress: progress,
    shouldHidePointIndicator: !currentSegment.isAvailable,
    shouldShowSummary: shouldShowSummary,
    children: flattenedBounds.map((segment, index) => /*#__PURE__*/_jsx(StepIndicatorItem, {
      index: index,
      isChecked: isChecked(segment.boundSegmentId),
      isCurrent: isCurrent(segment.boundSegmentId),
      isNotAvailable: !segment.isAvailable,
      isVisited: isVisited(segment.boundSegmentId),
      label: /*#__PURE__*/_jsx(FromToLabel, {
        from: segment.from.iata,
        to: segment.to.iata
      }),
      onClick: onStepIndicatorClick(segment),
      onItemSelected: onItemSelected,
      segmentLabel: `${segment.from.city}-${segment.to.city}`,
      segmentType: segment.__typename,
      stepAnimationDelay: calculateAnimationDelay(segment.boundSegmentId)
    }, generateKey(segment.boundSegmentId)))
  });
};
export default StepIndicator;
//# sourceMappingURL=StepIndicator.js.map